import React, { useState, useEffect, useRef } from "react";
// Libraries
import {useParams} from "react-router-dom";
import { Send, KeyboardBackspace } from "@material-ui/icons";
// Components
import MessagesList from "../../Components/Lists/MessagesList/MessagesList";
import { useHistory } from "react-router-dom";
// Styles
import {
  Container,
  ChatContainer,
  Title,
  Line,
  HalfLine,
  Chat,
  MessageSender,
  InputContainer,
  SendButton,
  TitleContainer,
  Image,
} from "./Messages.css";
import {useMessages} from "../../Hooks/useMessages";

const Messages = () => {
  let { requirementId } = useParams();
  requirementId = +requirementId;
  
  const history = useHistory();
  const [messages, sendMessage, markAsRead] = useMessages(requirementId);
  const [message, setMessage] = useState("");
  
  // Scroll chat to last message
  const messagesEndRef = useRef(null);
  const scrollToBottom = () =>
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
      markAsRead();
  }, [messages]);
    
  const onKeyPress = (event) => {
    if (event.key === "Enter") {
      submitMessage();
    }
  };

  const submitMessage = async () => {
    if (message) {
      await sendMessage(message);
      setMessage("");
    }
  };

  const messageSender = (
    <div className={MessageSender}>
      <input
        className={InputContainer}
        placeholder="Mensaje"
        value={message}
        onChange={(event) => setMessage(event.target.value)}
        {...{ onKeyPress }}
      />
      <Send
        className={SendButton}
        onClick={(e) => {
          e.preventDefault();
          submitMessage();
        }}
      />
    </div>
  );

  return (
    <div className={Container}>
      <div className={ChatContainer}>
        <div className={TitleContainer}>
          <KeyboardBackspace
            className={Image}
            onClick={(e) => {
              e.preventDefault();
              history.push('/requirements');
            }}
          />
          <h1 className={Title}>Mensajes</h1>
        </div>
        <div className={Line} />
        <div className={Chat}>
          <MessagesList data={messages} />
          <div ref={messagesEndRef} />
        </div>
        <div className={HalfLine} />
        {messageSender}
      </div>
    </div>
  );
};

Messages.propTypes = {};

export default Messages;



// WEBPACK FOOTER //
// ./src/Containers/Messages/Messages.js